import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import type { OrderTimelineEvent } from '@nebalkon-workspace/order-api';
import { StaffOrderDetailFacade } from './staff-order-detail.facade';
import {
  orderTimelineEventPresentation,
  type OrderTimelineEventPresentation,
} from './staff-order-timeline.util';

@Component({
  selector: 'lib-staff-order-detail-timeline',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, DatePipe],
  templateUrl: './staff-order-detail-timeline.component.html',
  styleUrl: './staff-order-detail-timeline.component.scss',
})
export class StaffOrderDetailTimelineComponent {
  readonly facade = inject(StaffOrderDetailFacade);
  readonly #translate = inject(TranslateService);

  readonly events = computed(() => this.facade.timeline());

  presentation(event: OrderTimelineEvent): OrderTimelineEventPresentation {
    return orderTimelineEventPresentation(event, (status) =>
      this.#translate.instant(this.facade.statusLabelKey(status)),
    );
  }
}
